/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {Html} from '@amblique/base/app/plugins/video/providers/html';
import {Vimeo} from '@amblique/base/app/plugins/video/providers/vimeo';
import {Youtube} from '@amblique/base/app/plugins/video/providers/youtube';

/**
 * Export supported video providers.
 * We can override this module from project level to reduce number of supported video providers.
 *
 * Order matters: providers are checked in order, so more specific patterns should come first.
 */
export const providers = [Html, Vimeo, Youtube];
